var exports = {
  "O3": "xfd349460--2ec7dd--underground",
  "dl": "xfd349460--2ec7dd--underground-station",
  "UI": "xfd349460--2ec7dd--underground-distance",
};

module.exports = exports;
